import styled from 'styled-components';
import { MdChat, MdImage } from 'react-icons/md';
import { FaCog } from 'react-icons/fa';
import { EVEN_LIGHTER_GREY_COLOR, PRIMARY_COLOR } from '../../constants';
import { desktopMediaQuery } from '../../styleHelpers';
import { useImageGenerationSettingsContext } from '../../context/ImageGenerationSettingsProvider';

const IconsRowContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 6px;
  gap: 16px;
  margin-top: -6px;
  ${desktopMediaQuery} {
    margin-left: 12px;
    margin-bottom: 4px;
    margin-top: 4px;
  }
`;

interface ModeIconProps {
  isSelected: boolean;
  cog?: boolean;
}

const ModeIcon = styled.div<ModeIconProps>`
  color: ${({ isSelected }) =>
    isSelected ? 'white' : EVEN_LIGHTER_GREY_COLOR};
  background-color: ${({ isSelected }) =>
    isSelected ? PRIMARY_COLOR : 'transparent'};
  border-radius: 4px;
  padding: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  margin-bottom: ${({ cog }) => (cog ? '1px' : '0px')};
  margin-left: ${({ cog }) => (cog ? '-1px' : '0px')};
  font-size: ${({ cog }) => (cog ? '19px' : '20px')};

  ${desktopMediaQuery} {
    &:hover {
      transform: scale(1.04);
      cursor: pointer;
    }
  }
`;

export type InputMode = 'chat' | 'image';

interface IconsRowProps {
  setIsHomePageSettingsModalOpen: (isOpen: boolean) => void;
}

const IconsRow = ({ setIsHomePageSettingsModalOpen }: IconsRowProps) => {
  const { setUserPrompt, homeGeneratorInputMode, setHomeGeneratorInputMode } =
    useImageGenerationSettingsContext();

  const handleSwitchBetweenModes = (mode: InputMode) => {
    setUserPrompt('');
    setHomeGeneratorInputMode(mode);
  };

  return (
    <IconsRowContainer>
      <ModeIcon
        as={MdImage}
        isSelected={homeGeneratorInputMode === 'image'}
        onClick={() => handleSwitchBetweenModes('image')}
      />
      <ModeIcon
        as={MdChat}
        isSelected={homeGeneratorInputMode === 'chat'}
        onClick={() => handleSwitchBetweenModes('chat')}
      />
      {homeGeneratorInputMode === 'image' && (
        <ModeIcon
          as={FaCog}
          cog={true}
          isSelected={false}
          onClick={() => setIsHomePageSettingsModalOpen(true)}
        />
      )}
    </IconsRowContainer>
  );
};

export default IconsRow;
